export const generateId = () => crypto.randomUUID();

export const formatDate = (val) => {
    if (!val) return 'Just now';
    let date;
    if (val instanceof Date) date = val;
    else if (typeof val === 'number') date = new Date(val);
    else if (val?.seconds) date = new Date(val.seconds * 1000);
    else return 'Just now';
    if (isNaN(date.getTime())) return 'Just now';
    return date.toLocaleDateString();
};

export const toDateObj = (val) => {
    if (!val) return null;
    if (val instanceof Date) return val;
    if (typeof val === 'number') return new Date(val);
    if (val?.seconds) return new Date(val.seconds * 1000);
    return new Date(val);
};

export const processHardModeWord = (word) => {
    if (!/^[a-zA-Z]+$/.test(word)) return word;
    const len = word.length;
    const suffixes = ['tion', 'ment', 'ing', 'ly', 'able', 'ible', 'ness', 'ity'];
    for (const suffix of suffixes) { if (word.endsWith(suffix) && len > suffix.length + 2) return word.slice(0, -suffix.length) + '_'.repeat(suffix.length); }
    if (len > 6) { const keepStart = 1; const keepEnd = 1; if (len > keepStart + keepEnd) return word.slice(0, keepStart) + '_'.repeat(len - keepStart - keepEnd) + word.slice(-keepEnd); }
    return word.replace(/[aeiou]/gi, '_');
};

export const getFolderPath = (folders, folderId) => {
    let path = [];
    let current = folders.find(f => f.id === folderId);
    const maxDepth = 5;
    let depth = 0;
    while (current && depth < maxDepth) {
        path.unshift(current.name);
        current = folders.find(f => f.id === current.parentId);
        depth++;
    }
    return path.join(' / ');
};
